import { tokens, View, Flex, Typography } from '@sapphire-react/core';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import backgroundImage from '../../images/background.png';

type Props = { isHidden: boolean };

export const TipsContainer: React.FC<Props> = ({ isHidden }: Props) => {
  const { t } = useTranslation();

  return (
    <BackgroundWrapper>
      <View
        borderRadius={tokens.size.radiusMd}
        width={'100%'}
        paddingTop={32}
        paddingBottom={32}
        display={isHidden ? 'none' : { base: 'none', sm: 'block' }}
        data-test-id={'tips-container'}
      >
        <Flex
          justifyContent={'space-between'}
          alignItems={'center'}
          height={'100%'}
          paddingLeft={32}
          paddingRight={32}
          gap={32}
        >
          <View height={'100%'}>
            <Typography.Heading
              level={4}
              UNSAFE_style={{ color: tokens.color.foregroundOnNegative.value }}
              marginBottom={tokens.size.spacingXs}
            >
              {t('tips.heading')}
            </Typography.Heading>

            <Typography.Body size={'sm'} UNSAFE_style={{ color: tokens.color.foregroundOnNegative.value }}>
              {t('tips.subHeading')}
            </Typography.Body>
          </View>
        </Flex>
      </View>
    </BackgroundWrapper>
  );
};

const BackgroundWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  background-image: url(${backgroundImage});
  background-size: cover;
  background-position: center;
  border-radius: ${tokens.size.radiusSm.value};
`;
